import React from 'react'
import { LinearProgress } from '@mui/material'

export default class Loader extends React.Component {
  render () {
    return <LinearProgress/>
  }
}
